<template>
    <div class="site-header-info__row" v-if="!isLogin && isMounted">
        <p class="site-header-info__mailmag">
            <a v-bind:href="path.signup" id="conversion_header">無料会員登録</a>
        </p>
        <p class="site-header-info__member">
            <a v-bind:href="path.login"
                ><svg class="icon-member">
                    <use xlink:href="#icon_sign_in"></use></svg
                >ログイン</a
            >
        </p>
        <!-- /.site-header-info__row -->
    </div>

    <div class="site-header-info__row" v-else-if="isMounted">
        <p class="site-header-info__logout">
            <a v-on:click="logout($event)" href="javascript:void(0);"
                ><svg class="icon-logout">
                    <use xlink:href="#icon_sign_in"></use></svg
                >ログアウト</a
            >
        </p>
        <p class="site-header-info__mypage">
            <a v-bind:href="path.profile"
                ><i class="fas fa-user"></i>マイページ</a
            >
        </p>
        <!-- /.site-header-info__row -->
    </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import axios from 'axios'
import fbauth from '../../fbauth.js'
import vuecommon from '../../vuecommon.js'

const config = require('AppConfig')

/**
 * ヘッダー部分 ログイン・ログアウトボタンの表示制御
 * 【削除予定】
 */
export default {
    name: 'headericon',
    mixins: [vuecommon],
    data() {
        return {
            path: config.path,
            isLogin: null,
            isMounted: false
        }
    },
    methods: {
        logout: function(e) {

            // 追加項目入力を促すフラグを削除
            window.localStorage.removeItem('additionalDict')
            e.stopPropagation()

            // サインアウト
            fbauth
                .logout()
                .then(() => {
                    this.setRedirectTimer('/')
                })
                .catch(err => {
                    console.log(err)
                })
        }
    },
    mounted: async function() {
        let self = this
        return firebase.auth().onAuthStateChanged(user => {
            //ヘッダアイコンのボタン表示の判定は基本的にクッキーのセッションのみで行う（プロフィールページは例外）
            if (user && location.pathname == config.path.profile) {
                self.isLogin = true
                self.isMounted = true
            } else {
                return axios
                    .post(config.api.sessionState, null, {
                        headers: {
                            'X-From': location.href
                        }
                    })
                    .then(response => {
                        if (
                            response &&
                            response.data &&
                            response.data.sessionstate &&
                            response.data.sessionstate['XPotaufeuLogin']
                        ) {
                            return response.data.sessionstate['XPotaufeuLogin']
                        } else {
                            return 0
                        }
                    })
                    .then(sessionstate => {
                        self.isLogin = sessionstate == 1 ? true : false
                    })
                    .catch(err => {
                        console.error(err)
                    })
                    .finally(() => {
                        self.isMounted = true
                    })
            }
        })
    }
}
</script>
